import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { consultant_helper } from "@/helpers/consultant_helper";

export default function ConsultantBioPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const consultant = consultant_helper.find(url_slug);
  return {
    props: {
      meta: { title: "About Us" },
      content: [
        // {
        //   component: "BreadcrumbNavigation",
        //   props: {
        //     items: [
        //       { label: "About Us", href: getRoute("about") },
        //       { label: "Meet the Team", href: getRoute("meet-the-team") },
        //       { label: consultant.consultant, href: getRoute("consultant", { url_slug: consultant.url_slug }) },
        //     ],
        //   },
        // },
        {
          component: "Header",
          props: {
            title: consultant.consultant ?? "Consultant",
            description: null,
            img: null,
            back: {
              path: getRoute("meet-the-team"),
              placeholder: "Back to team",
              href: getRoute("meet-the-team"),
            },
          },
        },
        {
          id: "TeamBio",
          component: "TeamBio",
          props: {
            role: consultant["job_title"] ?? "",
            email: consultant["email"] ?? "",
            linkedIn: consultant["linkedin_url"] ?? "",
            phone: consultant["phone"] ?? "",
            photo: consultant["image"] ?? "",
            description: consultant["about"] ?? "",
            reverse: true,
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  const paths = consultant_helper.toPaths();

  return {
    paths: paths,
    fallback: false,
  };
}
